<template>
	<div class="c-object-listing">
		<v-object-listing-data-provider :object-type="objectType" :api-url="apiUrl" :default-image-url="defaultImageUrl">
			<div class="o-grid" slot-scope="dataProvider">
				<div class="c-object-listing__utilities o-grid__column" data-size="sm:12" data-layout="spacious" id="utilities">
					<div>
						<p v-if="!dataProvider.isLoading" class="t-text-style-epsilon t-margin--2-bottom">Visar <span class="t-text-color--emphasis">{{dataProvider.currentObjects.length}}</span> {{objectTypeDisplay}}</p>
						<a href="#" class="t-reset-link" @click.prevent="dataProvider.resetAllFilters" v-if="dataProvider.filtersApplied && dataProvider.currentObjects.length === 0">
							{{resetAllText}}
						</a>
					</div>
				</div>
				<div class="c-object-listing__utilities c-object-listing__filtersarea o-grid__column" data-size="sm:12">
					<div class="c-object-listing__multiselectarea">
						<template v-for="(filter, index) in dataProvider.multiSelectFilters">
							<v-multi-select-development
							:key="`multiselect-${index}`" 
							v-if="filter && filter.items && filter.items.length > 0" 
							:label="filter.displayName" 
							:id="filter.name" 
							:options="filter.items"
							@optionSelected="dataProvider.setMultiSelectFilter"></v-multi-select-development>
						</template>
					</div>
					<!-- <div>
						<v-select-development
							label="Sortera efter"
							icon-at-small= "icon-order"
							id="sortObjectList"
							:visible-label="true"
							:selected='0'
							:options="options"
							@optionSelected="dataProvider.setSortOption">
						</v-select-development>
					</div> -->
				</div>
				<div class="c-loading o-grid__column" data-size="sm:12" v-if="dataProvider.isLoading">
					<div class="c-loading__circle">
					</div>
					<span class="c-loading__text">{{loadingText}}</span>
				</div>
				<div class="o-grid__column" data-size="sm:12">
				<div class="o-grid" v-if="!dataProvider.isLoading">
					<div
						v-for="(object, index) in dataProvider.currentObjects"
						:key="index"
						class="o-grid__column o-grid__column--heightauto"
						data-layout="spacious"
						:data-size="'sm:12 md:4'">
							 <v-object-development
								:image="object"
								:readMoreLabel="'Läs mer'"
							/>
					</div>
				</div>
				</div>
			</div>
		</v-object-listing-data-provider>
	</div>
</template>

<script>
import VSelectDevelopment from '../../../components/form-elements/select-development/VSelectDevelopment.vue';
import VIcon from '../../../components/icon/VIcon.vue';
import VFiltersWrapper from '../../../components/filters-wrapper/VFiltersWrapper.vue';
import VObjectDevelopment from '../../../components/object-listing/object-development/VObjectDevelopment.vue';
import VObjectListingDataProvider from '../../../components/object-listing/object-listing-data-provider/VObjectListingDataProvider.vue';
import VMultiSelectDevelopment from '../../../components/form-elements/multi-select-development/VMultiSelectDevelopment.vue';
import VRangeSlider from '../../../components/form-elements/range-slider/VRangeSlider.vue';
import VMap from '../../../components/map/map/VMap.vue';
// import { mockData } from './_mock/exampledata';

export default {
	name: 'VObjectListing',
	components: {
		VObjectDevelopment,
		VObjectListingDataProvider,
		VSelectDevelopment,
		VIcon,
		VFiltersWrapper,
		VMultiSelectDevelopment,
		VRangeSlider,
		VMap
	},
	props: {
		enableSorting: {
			type: Boolean,
			default: false
		},
		enableFilters: {
			type: Boolean,
			default: false
		},
		apiUrl: {
			type: String,
			default: ''
		},
		objectType: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: () => [
				{
					value: 'publishedDate',
					display: 'Publiceringsdatum'
				},
				{
					value: 'rentalStart',
					display: 'Tillträde'
				},
				{
					value: 'district',
					display: 'Område'
				}
			]
		},
		resetAllText: {
			type: String,
			default: 'Återställ val'
		},
		loadingText: {
			type: String,
			default: 'Laddar objekt'
		},
		defaultImageUrl: {
			type: String,
		},
	},
	/**
	 * Uncomment commented code above data area when you want to test with mockdata
	 * Also comment lines with <v-object-listing-data-provider> in the template above
	 * Replace <div class="o-grid" slot-scope="dataProvider"> with <div class="o-grid">
	 */
	// data() {
	// 	return {
	// 		dataProvider: mockData.dataProvider
	// 	}
	// },

	/**
	 * Uncomment methods area this when you want to sort locally
	 * Also replace dataProvider.setSortOption on line #34 to sortMock which is defined below
	 */
	// methods: {
	// 	sortMock(option) {
	// 		switch(option.value) {
	// 			case 'publishedDate':
	// 				this.dataProvider.currentObjects = this.dataProvider.currentObjects.sort((a, b) => (a.publishedDate < b.publishedDate)? 1 : -1);
	// 				break;
	// 			case 'rentalStart':
	// 				this.dataProvider.currentObjects = this.dataProvider.currentObjects.sort((a, b) => (a.rentalStart > b.rentalStart)? 1 : -1);
	// 				break;
	// 			case 'address':
	// 				this.dataProvider.currentObjects = this.dataProvider.currentObjects.sort((a, b) => (a.address > b.address)? 1 : -1);
	// 				break;
	// 			case 'district':
	// 				this.dataProvider.currentObjects = this.dataProvider.currentObjects.sort((a, b) => (a.district > b.district)? 1 : -1);
	// 				break;
	// 			default:
	// 				// Default sort by publishedDate
	// 				this.dataProvider.currentObjects = this.dataProvider.currentObjects.sort((a, b) => (a.publishedDate < b.publishedDate)? 1 : -1);
	// 		}
	// 	}
	// },
	computed: {
		objectTypeDisplay () {
			switch (this.objectType) {
				case 'apartment':
					return 'lägenheter';
				case 'premise':
					return 'lokaler';
				case 'district':
					return 'områden';
				default:
					return 'träffar';
			}
		},
	}
}
</script>
